<ul>
  <li
    [ngClass]="{ parent: breadcrumb.url }"
    *ngFor="let breadcrumb of breadcrumbs"
  >
    <a
      *ngIf="
        breadcrumb.url &&
        (!breadcrumb.navigationOption ||
          breadcrumb.navigationOption === NavigationOption_ROUTERLINK)
      "
      [routerLink]="breadcrumb.url"
    >
      <span class="left-arrow">&lsaquo;</span>
      {{ breadcrumb.text | translate }}
    </a>
    <a
      *ngIf="
        breadcrumb.url &&
        breadcrumb.navigationOption &&
        breadcrumb.navigationOption === NavigationOption_HREF
      "
      [href]="breadcrumb.url"
    >
      <span class="left-arrow">&lsaquo;</span>
      {{ breadcrumb.text | translate }}
    </a>
    <span *ngIf="!breadcrumb.url">
      {{ breadcrumb.text | translate }}
    </span>
    <span class="right-arrow">&rsaquo;</span>
  </li>
</ul>
